import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import Footer from './components/Footer'
import { IoIosArrowBack } from 'react-icons/io'
import { RiEditLine } from 'react-icons/ri'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import { banks } from './BankList'
import { payfastBanks } from './BankList'
import { bankBranchCodes } from './BankList'
import { predefinedBanks } from './BankList'
import ReEnterPasswordModal from './modals/verify-identity/ReEnterPasswordModal'
import { BiEdit, BiMenu } from 'react-icons/bi'
import { BsPencil } from 'react-icons/bs'
import { CheckUserLogin } from './sessions/CheckUserLoggin'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const EditBankDetails = () => {
  CheckUserLogin()
  const location = useLocation()
  const { responseCode, bankList } = location.state || {}
  const history = useHistory()
  const [bankName, setBankName] = React.useState('')
  const [ozowBankName, setOzowBankName] = useState('')
  const [ozowBankId, setOzowBankId] = useState(0)
  const [customBankName, setCustomBankName] = React.useState('')
  const [branchCode, setBranchCode] = React.useState('')
  const [customBranchCode, setCustomBranchCode] = React.useState('')
  const [accountNumber, setAccountNumber] = React.useState('')
  const [accountName, setAccountName] = React.useState('')
  const [accountType, setAccountType] = React.useState('')
  const [accountHolder, setAccountHolder] = React.useState('')
  const [createdAt, setCreatedAt] = React.useState('')
  const [message, setMessage] = React.useState('')
  const [error, setError] = React.useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errorDisplay, setErrorDisplay] = useState('d-none')
  const [alertState, setAlertState] = useState('success-alert')
  const [isMissing, setIsMissing] = useState(false)
  const [dataMissingMessage, setDataMissingMessage] = useState('')
  const [loggedAccountType, setLoggedAccountType] = useState('')
  const [bankLabel, setBankLabel] = useState('')
  const [count, setCount] = useState(0)
  const [isFound, setIsFound] = useState(true)
  const [loading, setLoading] = useState(false)
  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)
  const [ozowBankList, setOzowBankList] = useState([])

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  const ozowBanks = () => {
    // Axios.get(`${API_URL}/apps/kscanner/ozow.php`, { withCredentials: true })
    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=OZOWBANKLIST`, {
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data // Axios gives you parsed JSON here

        setOzowBankList(data)

        // console.log(data)
      })
      .catch((error) => {
        console.error('Error fetching banks:', error)
        setLoading(false)
      })
  }

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Edit bank details'

    ozowBanks()
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=RETRIEVEBANKDETAILS&business_id=${businessid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        const data = response.data
        if (data.status === 'failed') {
          setDataMissingMessage(data.message) // Return message if data is missing
          setIsMissing(true) // Set isMissing to true if there's an error or missing data
          console.log('Error: ', data.message)
          return
        }
        const custBankName = data.bank_name_edit.replace('_', ' ')
        setOzowBankId(data.ozowBankId)
        setLoggedAccountType(data.logged_account_type ?? '')
        setBankName(data.bank_name_edit ?? '')
        setOzowBankName(data.bank_name ?? '')
        setBranchCode(data.branch_code ?? '')
        setCustomBranchCode(data.branch_code ?? '')
        setAccountNumber(data.account_number_edit ?? '')
        setAccountHolder(data.account_holder ?? '')
        setAccountName(data.account_name ?? '')
        setAccountType(data.account_type_edit ?? '')
        setBankLabel(data.bank_label ?? '')
        setCustomBankName(
          isCustomBank
            ? custBankName
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            : '' ?? ''
        )
        setCreatedAt(data.created_at)
      })
      .catch(function (error) {
        console.log('Error: ', error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [count])

  const isCustomBank = !predefinedBanks.includes(bankName)

  const confirmPassword = (password) => {
    if (!password) {
      setError(true)
      setMessage('Please enter your password to verify your identity.')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    }

    const isInvalidBranch = Boolean(branchCode || customBranchCode)
    const isInvalidBank = Boolean(bankName || customBankName)
    // if (
    //   accountHolder.trim() === "" ||
    //   accountNumber.trim() === "" ||
    //   accountType.trim() === "" ||
    //   branchCode.trim() === "" ||
    //   bankName.trim() === ""
    // ) {
    //   setError(true);
    //   setMessage("All fields are required");
    //   setAlertState("error-alert");
    //   setErrorDisplay("d-block");
    //   setShowModal(false);

    //   setTimeout(() => {
    //     setErrorDisplay("d-none");
    //     setMessage("");
    //   }, 5000);
    //   return;
    // }
    // Verify the password before updating details
    setLoading(true)
    const data = new FormData()
    data.append('password', password)
    data.append('query', 'VERIFYIDENTITY')

    Axios.post(`${API_URL}/apps/kscanner/webservices.php`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        if (response.data.status === 'failed') {
          setLoading(false)
          setError(true)
          setMessage(response.data.message)
          setAlertState('error-alert')
          setErrorDisplay('d-block')
          setTimeout(() => {
            setErrorDisplay('d-none')
            setMessage('')
          }, 7000)
          return
        }

        // If password verification is successful, proceed to update details
        setError(false)
        updateDetails(accountHolder, accountName, accountNumber, accountType, branchCode, bankName)
        // setShowModal(false);
      })
      .catch((error) => {
        setLoading(false)
        console.error('Error verifying password:', error)
        setError(true)
        setMessage('An error occurred while verifying your password: ' + error)
        setAlertState('error-alert')
        setErrorDisplay('d-block')
        setTimeout(() => {
          setErrorDisplay('d-none')
          setMessage('')
        }, 5000)
        return
      })
  }

  // const handleBankUpdate = () => {
  //   setShowModal(true);
  // };

  const handleBankChange = (e) => {
    if (accounttype === 'customer') {
      const bank = e.target.value
      setBankName(bank)

      setBranchCode(bankBranchCodes[bank.split('_')[0]] || '')

      if (!bankBranchCodes[bank.split('_')[0]]) {
        setIsFound(false)
      } else {
        setIsFound(true)
      }
    } else {
      const bankId = e.target.value
      setOzowBankId(e.target.value)
      setBankName('null')

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=GET-OZOW-BANK-UNIVERSAL-BRANCH-CODE&bankId=${bankId}`,
        {
          withCredentials: true,
        }
      )
        .then((response) => {
          const data = response.data
          setBranchCode(data.branchCode)
          console.log(data.branchCode)
        })
        .catch((error) => {
          console.error('Error fetching banks:', error)
        })
    }
  }

  const updateDetails = (
    accountHolder,
    accountName,
    accountNumber,
    accountType,
    branchCode,
    bankName
  ) => {
    const businessid = localStorage.getItem('businessid')
    const baseURL = `${API_URL}/apps/kscanner/webservices.php`
    const dataForm = new FormData()
    dataForm.append('account_holder', accountHolder)
    dataForm.append('account_name', accountName)
    dataForm.append('account_number', accountNumber)
    dataForm.append('bank_account_type', accountType)
    dataForm.append('branch_code', branchCode)
    dataForm.append('bank_name', bankName)
    dataForm.append('custom_bank_name', customBankName)
    dataForm.append('ozowBankId', ozowBankId)
    dataForm.append('query', 'SAVEBANKDETAILS')

    Axios({
      method: 'post',
      url: baseURL,
      data: dataForm,
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        setCount(count + 1)
        const data = response.data
        if (data.status === 'failed') {
          setMessage(data.message)
          setError(true)
          console.log('Error: ', data.message)
          setAlertState('error-alert')
          setErrorDisplay('d-block')
          // setShowModal(true);

          return
        }
        setMessage(data.message)
        setError(false)
        console.log('Success: ', data.message)
        setAlertState('success-alert')
        setErrorDisplay('d-block')
        setShowModal(false)
      })
      .catch((error) => {
        console.log('Error: ', error)
        setMessage('An error occurred while updating details.')
        setAlertState('error-alert')
        setError(true)
      })

    setTimeout(() => {
      setErrorDisplay('d-none')
      setMessage('')
    }, 5000)
  }

  let bankNameList = banks

  if (responseCode === 'BANK_DETAILS_MISSING') {
    bankNameList = bankList
  }

  const selectedBank = `${bankName}_${bankLabel}`

  const addUpdate = () => {
    if (
      accountHolder.trim() === '' ||
      accountNumber.trim() === '' ||
      accountType.trim() === '' ||
      branchCode.trim() === '' ||
      bankName.trim() === ''
    ) {
      setError(true)
      setMessage('All fields are required')
      setAlertState('error-alert')
      setErrorDisplay('d-block')
      setShowModal(false)

      setTimeout(() => {
        setErrorDisplay('d-none')
        setMessage('')
      }, 5000)
      return
    } else {
      setShowModal(true)
    }
  }

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  const accounttype = localStorage.getItem('accounttype')

  return (
    <div className="view">
      <Header />
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : 'auto',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-12 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer pl-0 pr-0 mb-3">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0 pr-0">
                    <label className="ticket-title pl-0 pr-0 w-100">BANK DETAILS</label>
                  </div>
                </div>
                <div className="item-list p-0">
                  {isMissing ? (
                    <div
                      className="col-lg-12 text-left p-3 alert alert-warning"
                      style={{ borderRadius: 10 }}
                    >
                      {/* <label className="mb-0">{dataMissingMessage}</label> */}

                      <label className="mb-0">
                        <span>Important:</span>
                        <br />
                        Please ensure you enter correct banking details to avoid any issues with
                        payouts.
                      </label>
                    </div>
                  ) : (
                    <div className="col-lg-12 text-left p-0">
                      <label className="alert alert-warning p-2 mb-0 w-100">
                        <span>Important:</span>
                        <br />
                        Please ensure that your banking details are correct to avoid any issues with
                        payouts.
                      </label>
                    </div>
                  )}
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 details-body">
                Select your bank
                <br />
                {accounttype === 'customer' ? (
                  <select
                    className="form-control mb-3"
                    value={bankName}
                    onChange={handleBankChange}
                  >
                    {payfastBanks.map((bank) => (
                      <option key={bank.bank_name} value={`${bank.bank_name}_${bank.label}`}>
                        {bank.label}
                      </option>
                    ))}
                  </select>
                ) : (
                  // <select
                  //   className="form-control mb-3"
                  //   value={ozowBankName}
                  //   onChange={handleBankChange}
                  // >
                  //   <option value={''}>--Select--</option>
                  //   {ozowBankList.map((bank) => (
                  //     <option key={bank.rowId} value={`${bank.rowId}`}>
                  //       {bank.bankGroupName}
                  //     </option>
                  //   ))}
                  // </select>

                  <select
                    className="form-control mb-3"
                    value={ozowBankId} // controlled by rowId
                    onChange={handleBankChange}
                  >
                    <option value="">--Select--</option>
                    {ozowBankList.map(({ rowId, bankGroupName }) => (
                      <option key={rowId} value={rowId}>
                        {bankGroupName}
                      </option>
                    ))}
                  </select>
                )}
                Branch code
                <br />
                <input
                  type="number"
                  placeholder="Type branch code here"
                  className="form-control edit-input"
                  value={branchCode}
                  onChange={(e) => setBranchCode(e.target.value)}
                  readOnly={isFound ? true : false}
                />
                <br />
                Account holder
                <br />
                <input
                  type="text"
                  className="form-control edit-input"
                  value={accountHolder}
                  onChange={(e) => setAccountHolder(e.target.value)}
                />
                <br />
                Account number
                <br />
                <input
                  type="text"
                  className="form-control edit-input"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
                <br />
                Type of account
                <br />
                <select
                  className="form-control edit-input"
                  value={accountType}
                  onChange={(e) => setAccountType(e.target.value)}
                >
                  <option value="">--Select--</option>
                  <option value={accounttype === 'customer' ? 'savings' : 'cheque'}>
                    Cheque/Current
                  </option>
                  <option value="savings">Savings</option>
                  {/* <option value="business">Business</option> */}
                  {/* <option value="Other">Other</option> */}
                </select>
                <br />
                <br />
                Details updated on
                <br />
                <label className="small-details">{createdAt ? createdAt : 'N/A'}</label>
              </div>
              <div className="col-12 text-right mt-3">
                <label className="back-arrow mb-0">
                  <button className="save-btn" onClick={() => addUpdate()}>
                    Add/Update
                  </button>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReEnterPasswordModal
        isOpen={showModal}
        onConfirm={confirmPassword}
        onCancel={() => setShowModal(false)}
        loading={loading}
      />
      <div className={alertState + ' text-center ' + errorDisplay}>{message}</div>
      {/* <Footer /> */}
    </div>
  )
}

export default EditBankDetails
